






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class EmptyStateTable extends Vue {
  @Prop(String) text!: string;
}
